import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from '@cotyorg/ccx-atoms/Link';

const generateLinkClassNames = ({ isSelected }) =>
  classNames('subcategory-navigation__link', {
    'subcategory-navigation__link--is-selected': isSelected,
  });

const generateListItemClassNames = (isHiddenList) =>
  classNames('subcategory-navigation__list-item', 'align-center', {
    'flex-container': isHiddenList,
  });

const SubcategoryNavigationList = ({ items, isHiddenList }) => (
  <ul className="subcategory-navigation__list">
    {items.map(({ name, slug, url, isSelected }) => (
      <li key={slug} className={generateListItemClassNames(isHiddenList)}>
        <Link extraClass={generateLinkClassNames({ isSelected })} link={url}>
          <span className="subcategory-navigation__link-text subcategory-navigation__link-text--hidden-sub-nav cell">
            {name}
          </span>
        </Link>
      </li>
    ))}
  </ul>
);

SubcategoryNavigationList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isHiddenList: PropTypes.bool,
};

export default SubcategoryNavigationList;
